import { Page, PageHeader } from "@/components/Bits";
import RecurringAccruals from "@/components/RecurringAccruals";

export default function RecurringAccrualsPage() {
  return (
    <Page>
      <PageHeader overline="Optimisation" title="Recurring Accruals"
        subtitle="Suppliers regularly billed but missing for the current month — post predicted accruals with auto or smart-matched reversals." />
      <RecurringAccruals standalone />
    </Page>
  );
}
